import { NAME } from './constants';

export const getFlights = state => state[NAME];
export const isLoaded = globalState => (globalState[NAME] && globalState[NAME].loaded);



// WEBPACK FOOTER //
// ./modules/MultiFlight/redux/selectors.js